import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { BUILDER_TAGS } from '@/courses/values/courses.values';

@Component({})
export default class EdSelectTagComponent extends Vue {
  @Prop() tags: Array<string>;
  @Prop() label: string;
  @Prop({default: false}) fullWidth: boolean;
  @Prop({default: true}) singleLine: boolean;

  public tagsValues: Array<string>;
  selectedChip = null;

  getEdIcon(tag) {
    let icon;
    switch(tag) {
      case BUILDER_TAGS.HOMEWORK:
        icon = 'house-solid'
        break;
      case BUILDER_TAGS.CLASSWORK:
        icon = 'building-solid'
        break;
      default: // TEST
        icon = 'user-edit'
        break
    }
    return icon
  }

  mounted() {
    this.selectedChip = this.$attrs.value;
  }

  toggleChip(value) {
    this.selectedChip = this.selectedChip === value ? null : value;
    this.$emit('input', this.selectedChip);
  }
}